import type { PendingToolApproval } from '../../contracts';

export const readApprovalLabel = (approval: PendingToolApproval): string | undefined => {
  return readApprovalLabelFromToolInput(approval.toolInput);
};

export const readApprovalLabelFromToolInput = (
  input: Record<string, unknown> | null | undefined
): string | undefined => {
  const normalizedInput = input ?? {};
  const rawTask = normalizedInput.raw_task;
  if (typeof rawTask === 'string' && rawTask.trim()) return rawTask.trim();
  const task = normalizedInput.task;
  if (typeof task === 'string' && task.trim()) return task.trim();
  return undefined;
};
